import { ContractingFormType } from "features/contracting/enums/contractingFormType";
import ContractingStepSummaryProps from "features/contracting/models/ContractingStepSummaryProps";
import CustomerTypeSummary from "./CustomerTypeSummary";
import CustomerDataSummary from "./CustomerDataSummary";
import PaymentMethodSummary from "./PaymentMethodSummary";
import ProcessSummary from "./ProcessSummary";
import PlaceOfDeliverySummary from "./PlaceOfDeliverySummary";
import ProductSummary from "./ProductSummary";
import OverviewSummary from "./OverviewSummary";

type ContractingSummary = (pros: ContractingStepSummaryProps) => JSX.Element;
type ComponentMap = Record<ContractingFormType, ContractingSummary>;

export const ContractingSummariesMap: ComponentMap = {
  "customerType": CustomerTypeSummary,
  "customerData": CustomerDataSummary,
  "paymentMethod": PaymentMethodSummary,
  "process": ProcessSummary,
  "placeOfDelivery": PlaceOfDeliverySummary,
  "product": ProductSummary,
  "overview": OverviewSummary
}